import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import logOutIcon from '../../../Assets/images/svg/logout_icon.svg';

const ProfileSection = ({ user, initials, isOpen, handleLogoutClick }) => {
  const navigate = useNavigate();
  const [hovered, setHovered] = useState(false);

  const handleProfileClick = () => {
    navigate('/employee-profile', { state: { emailId: user.mailId } });
  };

  return (
    <div className={`profile-div ${isOpen ? 'expanded' : 'collapsed'}`}>
      <button
        className="avatar"
        style={{ opacity: hovered ? 0.7 : 1 }}
        onClick={handleProfileClick}
      >
        <div className="avatar-circle">
          {user.profilePic ? (
            <img
              src={user.profilePic}
              alt="Profile"
              referrerPolicy="no-referrer"
            />
          ) : (
            initials
          )}
        </div>
      </button>

      {isOpen && (
        <>
          <button
            className="name"
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
            onClick={handleProfileClick}
          >
            {user.name}
          </button>
          <div className="mail-id">{user.mailId}</div>
        </>
      )}

      <div className="log-out">
        {isOpen && (
          <button
            id="logout-text"
            className="logout-text"
            onClick={handleLogoutClick}
          >
            Logout
          </button>
        )}
        <button
          id="logout-icon"
          className="logout-button"
          onClick={handleLogoutClick}
        >
          <img src={logOutIcon} alt="Logout" />
        </button>
      </div>
    </div>
  );
};

ProfileSection.propTypes = {
  user: PropTypes.shape({
    profilePic: PropTypes.string,
    name: PropTypes.string.isRequired,
    mailId: PropTypes.string.isRequired,
  }).isRequired,
  initials: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  handleLogoutClick: PropTypes.func.isRequired,
};

export default ProfileSection;
